module.exports = __webpack_public_path__ + "img/logo_L.d230e68a.png";